export default __webpack_public_path__ + "static/media/Control.079427d3.png";